import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { AppContext } from '../../AppProvider';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import BOLStyles from './__styles__/BOL.styles';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';

class Services extends Component {
  static propTypes = {
    shipment: PropTypes.object.isRequired
  };

  render() {
    const { classes, t, shipment } = this.props;

    return (
      <Fragment>
        <Grid item xs={6}>
          <span className={classnames(classes.textMargin, classes.headerText)}>
            {t('Services')}:{' '}
            <span className={classnames(classes.bolFont)}>
              {shipment.requestedServices.join(', ')}
            </span>
          </span>
        </Grid>
      </Fragment>
    );
  }
}

Services.contextType = AppContext;
const translatedServices = withNamespaces()(Services);
export default withStyles(
  combineStyles(
    BOLStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(translatedServices);
